import React from 'react'

import styles from './styles.module.css'

interface IErrorMessage {
  readonly errorMessage: string
}

export function ErrorMessage({ errorMessage }: IErrorMessage) {
  return (
    <span data-testid="suggester-error-msg" className={styles.message}>
      {errorMessage}
    </span>
  )
}
